import {useSelector} from 'react-redux'
import {useEffect, useState} from 'react'
import {useHistory, useParams} from 'react-router-dom'
import {RootState} from '../../../../setup'
import {QueryData} from '../../../reusable-components/tables/DynamicTableTypes'
import {toast} from 'react-toastify'
import TableTitle from '../../../reusable-components/tables/TableTitle'
import TableWrapper from '../../../reusable-components/tables/TableWrapper'
import TableSearchBar from '../../../reusable-components/tables/TableSearchBar'
import {hasPermission} from '../../../../_helper/hasPermission'
import {permissions} from '../../../../_constants/permissions'
import DynamicTable from '../../../reusable-components/tables/DynamicTable'
import AddButton from '../../../reusable-components/Buttons/AddButton'
import axios from 'axios'
import {
  BEHAVIOUR_COLUMNS_DATA_MAPPING,
  BEHAVIOUR_LISTING_COLUMNS,
  BEHAVIOUR_SORTING_COLUMNS,
} from './BEHAVIOUR_TABLE_CONSTANTS'
import dayjs from 'dayjs'
const selectAuth = (state: RootState) => state.auth
const selectTimeZone = (state: RootState) => state.timeZone.timeZone

export const BehaviourListNotes = () => {
  const [filteredData, setFilteredData] = useState<any[]>([])
  const [fullData, setFullData] = useState<any[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const [loadingStates, setLoadingStates] = useState({})
  const [deletedID, setDeletedID] = useState('')
  const [isFetchingData, setIsFetchingData] = useState(true)
  const auth = useSelector(selectAuth)
  const userPermissions = auth.user.roleId
  const history = useHistory()
  const timeZone = useSelector(selectTimeZone)
  const companyLogo = auth?.user?.companyLogo;
  const [logoUrl, setLogoUrl] = useState('');
  const [isPDFDownloaded, setIsPDFDownloaded] = useState(false);
  const [queryData, setQueryData] = useState<QueryData>({
    pageNumber: 1,
    pageSize: 5,
    currentPage: 1,
    totalCounts: 1,
    sortBy: '_id',
    sortDir: 'desc',
    searchTerm: '',
  })
  const {id, clientId, noteType}: {id: string, clientId: string, noteType: string} = useParams()
  useEffect(() => {
    const fetchData = async ( page: number, pageSize: number, sortBy: string, sortDir: string) => {
      setIsFetchingData(true)
      try {
        const response = await axios.get(`/progressNotes/getAll/${clientId}?noteType=${noteType}&page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortDir=${sortDir}&searchTerm=${queryData.searchTerm}`)
        const { data: result, currentPage, totalCounts } = response.data
        setFullData(result)
        setQueryData((prevState) => {
          return {
              ...prevState,
              currentPage,
              totalCounts,
          }});
        setFilteredData(result)
      } catch (error: any) {
        if (axios.isCancel(error)) {
          console.log('Request canceled', error.message)
        } else {
          console.log('Error:', error.message)
        }
      } finally {
        setIsFetchingData(false)
      }
    }

    fetchData(queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir)
  }, [deletedID, queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir, queryData.searchTerm, isPDFDownloaded])
   const fetchPresignedUrl = async (key: string, objective: string) => {
      try {
        if (key?.startsWith("http")) {
          console.log("Already a URL, skipping presigned URL fetch.");
          if(objective === 'companyLogo'){
            setLogoUrl(key); 
          }
          return;
        }
    
        const response = await axios.get(`/batchfile/fetch-file-url`, {
          params: { fileKey: key },
        });
    
        if (response.status === 200) {
          if(objective === 'companyLogo'){
            setLogoUrl(response.data.presignedUrl);
          } else if(objective === 'pdf'){
            return response.data.presignedUrl;
          }
        }
      } catch (error) {
        console.error("Error fetching company logo URL:", error);
      }
    };
    
    useEffect(() => {
      if (companyLogo) {
        fetchPresignedUrl(companyLogo, 'companyLogo');
      }
    }, [companyLogo]);
  const onUpdate = ({_id}: {_id: string}) => {
    history.push({
      pathname: `/notes/behavior-notes/edit/${_id}`,
    })
  }
  const onClickAddButton = () => {
    history.push(`/notes/behavior-notes/new/${id}/${clientId}/${noteType}`)
  }

  const DeleteNote = async (row: {_id: string}) => {
    try {
      const res = await axios.delete(`/progressNotes/delete/${row._id}`)
      toast.success(res.data.message || 'Note deleted successfully')
      setDeletedID(row._id)
    } catch (e) {
      toast.error(e?.response?.data?.error || 'Failed to delete note')
      console.error('Delete error:', e)
    }
  }
  const setLoading = (id, action, isLoading) => {
    setLoadingStates((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [action]: isLoading,
      },
    }))
  }
  const onDownload = async (row) => {
    try {
      setLoading(row._id, 'download', true);
      if(row?.isPdfGenerated){
        setIsPDFDownloaded(row?._id)
        const presignedUrl = await fetchPresignedUrl(row?.pdfS3Key, 'pdf')
        
        // Use the presigned URL directly for download
        const link = document.createElement('a')
        link.href = presignedUrl
        link.setAttribute('download', `${row?.noteType}_Behavior_Note_for_${row?.clientFullName}.pdf`);
        link.setAttribute('target', '_blank')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
        setLoading(row._id, 'download', false)
        return
      }
      let finalCompanyLogoUrl = '';
      if (companyLogo?.startsWith('http')) {
        finalCompanyLogoUrl = companyLogo;
      } else {
        finalCompanyLogoUrl = logoUrl;
      }
      const filteredRowData = fullData?.find((item) => item._id === row._id);
      if (!filteredRowData) {
        console.error('No data found for this row');
        setLoading(row._id, 'download', false);
        return;
      }
  
    const formattedNextAppt = filteredRowData?.nextAppointment
      ? dayjs.utc(filteredRowData.nextAppointment).tz(timeZone, true).format('MM-DD-YYYY')
      : null;

    const formattedStartDate = filteredRowData?.startDate
      ? dayjs.utc(filteredRowData.startDate).tz(timeZone, true).format('MM-DD-YYYY')
      : 'No details provided';

    const formattedEndDate = filteredRowData?.endDate
      ? dayjs.utc(filteredRowData.endDate).tz(timeZone, true).format('MM-DD-YYYY')
      : 'No details provided';
  
      const formData = {
        ...filteredRowData,
        clientId: filteredRowData.clientId,
        companyLogoUrl: finalCompanyLogoUrl,
  
        historyOfIllness: {
          location: filteredRowData?.historyOfIllness?.location || 'No details provided',
          duration: filteredRowData?.historyOfIllness?.duration || 'No details provided',
          timing: filteredRowData?.historyOfIllness?.timing || 'No details provided',
          associatedSymptoms: filteredRowData?.historyOfIllness?.associatedSymptoms || 'No details provided',
          medicalHx: filteredRowData?.historyOfIllness?.medicalHx || 'No details provided',
        },
  
        goalsObjectives: filteredRowData?.goalsObjectives || 'No details provided',
        evidenceOfResponse: filteredRowData?.evidenceOfResponse || 'No details provided',
        interventionStudies: filteredRowData?.interventionStudies || 'No details provided',
        sessionContent: filteredRowData?.sessionContent || 'No details provided',
        futureTreatment: filteredRowData?.futureTreatment || 'No details provided',
        assignedHomework: filteredRowData?.assignedHomework || 'No details provided',
        nextAppointment: formattedNextAppt,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        mood: filteredRowData?.mood || 'No details provided',
        appearance: filteredRowData?.appearance || 'No details provided',
        speech: filteredRowData?.speech || 'No details provided',
        behaviour: filteredRowData?.behaviour || 'No details provided',
        affect: filteredRowData?.affect || 'No details provided',
        thoughtContent: filteredRowData?.thoughtContent || 'No details provided',
        thoughtProcess: filteredRowData?.thoughtProcess || 'No details provided',
        judgment: filteredRowData?.judgment || 'No details provided',
        insights: filteredRowData?.insights || 'No details provided',
        participants: filteredRowData?.participants || 'No details provided',
        status: filteredRowData?.status || 'No details provided',
        responseToTx: filteredRowData?.responseToTx || 'No details provided',
        dangerTo: filteredRowData?.dangerTo || 'No details provided',
        sessionDate: filteredRowData?.sessionDate || 'No details provided',
        noteType: filteredRowData?.noteType || 'No details provided',
        timeIn: filteredRowData?.timeIn,
        timeOut: filteredRowData?.timeOut,
        diagnosis: filteredRowData?.diagnosis || 'No details provided',
        medications: filteredRowData?.medications || 'No details provided',
        createdAt: filteredRowData?.createdAt,
      };
      
  
      const response = await axios.post('/progressNotes/generateBehaviorNotesPDF', formData, {
        responseType: 'blob',
      });
  
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${filteredRowData.noteType}_Behavior_Note_for_${filteredRowData.clientFullName}.pdf`);
      document.body.appendChild(link);
      link.click();
  
      setLoading(row._id, 'download', false);
      setIsPDFDownloaded(row?._id)
    } catch (err) {
      console.error('Error while downloading behavior note', err);
      setLoading(row._id, 'download', false);
    }
  };

  return (
    <div className='card'>
      <div className='card-body'>
        <TableTitle title='Behavior Notes' />
        <TableWrapper
          searchField={
            <TableSearchBar
              label='Search'
              variant='outlined'
              size='small'
              value={searchTerm}
              setQueryData={setQueryData}
              setSearchTerm={setSearchTerm}
              margin='normal'
              inputAdornmentPosition='start'
            />
          }
          tableButtons={
            hasPermission(userPermissions, permissions.notes_behavior_note_entry_create) && (
              <AddButton onClick={onClickAddButton} />
            )
          }
          dynamicTable={
            <DynamicTable
              htmlColumns={[]}
              canDownload={true}
              onDownload={onDownload}
              columns={BEHAVIOUR_LISTING_COLUMNS}
              data={filteredData}
              canUpdate={hasPermission(userPermissions, permissions.notes_behavior_note_entry_update)}
              canDelete={hasPermission(userPermissions, permissions.notes_behavior_note_entry_delete)}
              columnDataMapping={BEHAVIOUR_COLUMNS_DATA_MAPPING}
              sortingColumns={BEHAVIOUR_SORTING_COLUMNS}
              clickableRow={false}
              loadingStates={loadingStates}
              onUpdate={onUpdate}
              onDelete={DeleteNote}
              title='Are you sure you want to delete the note'
              setQueryData={setQueryData}
              queryData={queryData}
            />
          }
        />
      </div>
    </div>
  )
}
